import { gql } from "@apollo/client";
export const APP_FILES_DELETE = gql `
  mutation AppFilesDeleteOne($id: ObjectId!) {
    AppFilesDeleteOne(_id: $id)
  }
`;
